import { get, post } from "@/utils/request";
import type { Recall, CommonForm, Detail } from "@/types/procss";
import type { Response } from "@/types/axios";

//开户申请
export const getBankAccountApply = (params: {
  BranchCompanyFlowId: number | string;
}): Promise<Response<Detail>> =>
  post("/api/bankAccount/getBankAccountApply", params);

export const startBankAccountApply = (
  params: CommonForm
): Promise<Response<Detail>> =>
  post("/api/bankAccount/startBankAccountApply", params);

//税务报道
export const getTaxReporting = (params: {
  BranchCompanyFlowId: number | string;
}): Promise<Response<Detail>> =>
  post("/api/bankAccount/getTaxReporting", params);

export const startTaxReporting = (
  params: CommonForm
): Promise<Response<Detail>> =>
  post("/api/bankAccount/startTaxReporting", params);

export const getBankAccountRegistration = (params: {
  BranchCompanyFlowId: number | string;
}): Promise<Response<Detail>> =>
  post("/api/bankAccount/getBankAccountRegistration", params);

export const startBankAccountRegistration = (params: {
  params: CommonForm;
}): Promise<Response<Detail>> =>
  post("/api/bankAccount/startBankAccountRegistration", params);

//提交开户报税申请(包括重新发起申请)
export const submitAccountTaxApply = (params: {
  params: CommonForm;
}): Promise<Response<Detail>> =>
  post("/api/bankAccount/submitAccountTaxApply", params);

//开户报税申请详情
export const accountTaxApplyInfo = (params: {
  params: CommonForm;
}): Promise<Response<Detail>> =>
  post("/api/bankAccount/accountTaxApplyInfo", params);

//提交税种申请(包括重新发起申请)
export const submitTaxCategoryApply = (params: {
  params: CommonForm;
}): Promise<Response<Detail>> =>
  post("/api/bankAccount/submitTaxCategoryApply", params);

//税种申请详情
export const taxCategoryApplyInfo = (params: {
  params: CommonForm;
}): Promise<Response<Detail>> =>
  post("/api/bankAccount/taxCategoryApplyInfo", params);
